export default __webpack_public_path__ + "static/GIF-535549184c24d00aa02e11d11ddae57d.gif";